import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import HeaderButtons from '@components/header-buttons/HeaderButtons';
import HeaderLogo from '@components/header-logo/HeaderLogo';
import ModalMenuRoutes from '@components/modal-menu-routes/ModalMenuRoutes';
import Wrapper from '@components/wrapper/Wrapper';
import { handleOpenMenuMobile, menuMobileSelector } from '@lib/store/slices/ComponentsSlice';
import { CONTACTS } from '@lib/tools/helpers/constants';
import { animated, useSpring } from '@react-spring/web';
import Link from 'next/link';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './MenuMobile.module.scss';
function MenuMobile() {
  const $ = _c(52);
  const dispatch = useDispatch();
  const openMenuMobile = useSelector(menuMobileSelector);
  const [toggle, setToggle] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      duration: 500
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = toggle ? 0 : 1;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      config: t0,
      opacity: t1,
      delay: 0
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const animatedStyle = useSpring(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 500
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = toggle ? 1 : 0;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      config: t3,
      opacity: t4,
      delay: 0
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const animatedStyleHr2 = useSpring(t5);
  const windowWidth = window.innerWidth;
  const xTranslationHr1 = toggle ? "0px" : `${0.014492753623188406 * windowWidth}px`;
  const yTranslationHr1 = toggle ? "0px" : `${0.007246376811594203 * windowWidth}px`;
  const rotationHr1 = toggle ? 0 : -45;
  const xTranslationHr3 = toggle ? "0px" : `${0.014492753623188406 * windowWidth}px`;
  const yTranslationHr3 = toggle ? "0px" : `${-0.036231884057971016 * windowWidth}px`;
  const rotationHr3 = toggle ? 0 : 45;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 500
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `translateX(${xTranslationHr1}) translateY(${yTranslationHr1}) rotate(${rotationHr1}deg)`;
  let t8;
  if ($[7] !== t7) {
    t8 = {
      config: t6,
      transform: t7,
      delay: 0
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const animatedStyleHr1 = useSpring(t8);
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      duration: 500
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = `translateX(${xTranslationHr3}) translateY(${yTranslationHr3}) rotate(${rotationHr3}deg)`;
  let t11;
  if ($[10] !== t10) {
    t11 = {
      config: t9,
      transform: t10,
      delay: 0
    };
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const animatedStyleHr3 = useSpring(t11);
  let t12;
  let t13;
  if ($[12] !== openMenuMobile) {
    t12 = () => {
      if (openMenuMobile) {
        setToggle(true);
        setTimeout(() => {
          setToggle(false);
        }, 400);
      }
    };
    t13 = [openMenuMobile];
    $[12] = openMenuMobile;
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  useEffect(t12, t13);
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [];
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  useEffect(_temp2, t14);
  const svgRef = useRef(null);
  const [toggle2, setToggle2] = useState(false);
  let t15;
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      if (svgRef) {
        setTimeout(() => {
          setToggle2(_temp3);
        }, 800);
      }
    };
    t16 = [svgRef];
    $[16] = t15;
    $[17] = t16;
  } else {
    t15 = $[16];
    t16 = $[17];
  }
  useLayoutEffect(t15, t16);
  let t17;
  if ($[18] !== dispatch) {
    t17 = () => {
      dispatch(handleOpenMenuMobile(false));
    };
    $[18] = dispatch;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const handleScrollTop = t17;
  let t18;
  if ($[20] !== animatedStyle) {
    t18 = {
      ...animatedStyle
    };
    $[20] = animatedStyle;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== toggle2) {
    t19 = <div className={style.menuMobileSvg}><AnimateLines id="vector_5_mob" className={style.svgClass} toggle={toggle2} /></div>;
    $[22] = toggle2;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== handleScrollTop) {
    t20 = <div className={style.menuMobileLogo}><HeaderLogo color="black" handleScrollTop={handleScrollTop} /></div>;
    $[24] = handleScrollTop;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== dispatch) {
    t21 = () => {
      dispatch(handleOpenMenuMobile(false));
    };
    $[26] = dispatch;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <rect y="0.631348" width="25" height="1.31579" rx="0.657895" fill="black" />;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== animatedStyleHr1) {
    t23 = <animated.svg style={animatedStyleHr1} className={style.svgClassHr_1} viewBox="0 0 25 2" fill="none" xmlns="http://www.w3.org/2000/svg">{t22}</animated.svg>;
    $[29] = animatedStyleHr1;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <rect y="0.631348" width="25" height="1.31579" rx="0.657895" fill="black" />;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== animatedStyleHr2) {
    t25 = <animated.svg style={animatedStyleHr2} className={style.svgClassHr_1} viewBox="0 0 25 2" fill="none" xmlns="http://www.w3.org/2000/svg">{t24}</animated.svg>;
    $[32] = animatedStyleHr2;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <rect y="0.631348" width="25" height="1.31579" rx="0.657895" fill="black" />;
    $[34] = t26;
  } else {
    t26 = $[34];
  }
  let t27;
  if ($[35] !== animatedStyleHr3) {
    t27 = <animated.svg style={animatedStyleHr3} className={style.svgClassHr_1} viewBox="0 0 25 2" fill="none" xmlns="http://www.w3.org/2000/svg">{t26}</animated.svg>;
    $[35] = animatedStyleHr3;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  let t28;
  if ($[37] !== t21 || $[38] !== t23 || $[39] !== t25 || $[40] !== t27) {
    t28 = <div className={style.menuMobileBurgerMenu} onClick={t21} role="button" tabIndex="0">{t23}{t25}{t27}</div>;
    $[37] = t21;
    $[38] = t23;
    $[39] = t25;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t20 || $[43] !== t28) {
    t29 = <div className={style.menuMobileBox}>{t20}{t28}</div>;
    $[42] = t20;
    $[43] = t28;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  let t31;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <HeaderButtons toggleWhite={true} headerColorScheme="" />;
    t31 = <ModalMenuRoutes />;
    $[45] = t30;
    $[46] = t31;
  } else {
    t30 = $[45];
    t31 = $[46];
  }
  let t32;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Wrapper><div className={style.menuMobile}>{t30}{t31}<div><div className={style.menuMobile__links}><Link className={style.menuMobile__link} href={"mailto:" + CONTACTS.MAIL}>{CONTACTS.MAIL}</Link><Link suppressHydrationWarning={true} className={style.menuMobile__link} href={"tel:" + CONTACTS.PHONE}>{CONTACTS.PHONE}</Link></div></div></div></Wrapper>;
    $[47] = t32;
  } else {
    t32 = $[47];
  }
  let t33;
  if ($[48] !== t18 || $[49] !== t19 || $[50] !== t29) {
    t33 = <><animated.div className={style.menuMobileContainer} style={t18} ref={svgRef}>{t19}{t29}{t32}</animated.div></>;
    $[48] = t18;
    $[49] = t19;
    $[50] = t29;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  return t33;
}
function _temp3() {
  return true;
}
function _temp2() {
  document.body.style.overflow = "hidden";
  return _temp;
}
function _temp() {
  document.body.style.overflow = "auto";
}
export default MenuMobile;